/* eslint react/prop-types: 0 */

import React, { useState, useEffect } from "react";
import { Loader, Button } from "semantic-ui-react";
import { useSelector } from "react-redux";
import numeral from "numeral";
import { InputFieldResponsive, InputFieldResponsive2 } from "../../component/Utils";
import { lpe as formula } from "../../utils/financeFormula";
import Table from 'react-bootstrap/Table';

export const Lpe = (props) => {
  const user = useSelector((state) => state.main.dataUser);
  const filter = useSelector((state) => state.main);
  const reportReducer = useSelector((state) => state.reportReducer);

  const disabledInput = user.role < 4;

  const [dataInput, setDataInput] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    const stringFields = ["catatan"];
    let v = value;
    if (stringFields.indexOf(name) < 0) v = parseInt(value);
    setDataInput({
      ...dataInput,
      [name]: v,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.postData(dataInput);
  };

  useEffect(() => {
    const data = reportReducer.dataReport
      ? reportReducer.dataReport.content[0]
      : null;
    setDataInput({
      ...data,

      // modal Saham
      msSaldoAwalTahunThLalu: data ? data.msSaldoAwalTahunThLalu : null,
      msPenyesuaianAwalTahunThLalu: data ? data.msPenyesuaianAwalTahunThLalu : null,
      msSaldoSetelahPenyesuaianThLalu: data ? data.msSaldoSetelahPenyesuaianThLalu : null,
      msPembagianLabaDividenThLalu: data ? data.msPembagianLabaDividenThLalu : null,
      msPembagianLabaCadanganThLalu: data ? data.msPembagianLabaCadanganThLalu : null,
      msPembagianLabaTantiemJasprodThLalu: data ? data.msPembagianLabaTantiemJasprodThLalu : null,
      msTambahanModalDisetorThLalu: data ? data.msTambahanModalDisetorThLalu : null,
      msLabaRugiTahunBerjalanThLalu: data ? data.msLabaRugiTahunBerjalanThLalu : null,
      msPenambahanEkuitasLainnyaThLalu: data ? data.msPenambahanEkuitasLainnyaThLalu : null,
      msPenghasilanKomprehensifLainThLalu: data ? data.msPenghasilanKomprehensifLainThLalu : null,
      msSaldoAkhirThLalu: data ? data.msSaldoAkhirThLalu : null,

      msPenyesuaianAwalTahunThIni: data ? data.msPenyesuaianAwalTahunThIni : null,
      msSaldoSetelahPenyesuaianThIni: data ? data.msSaldoSetelahPenyesuaianThIni : null,
      msPembagianLabaDividenThIni: data ? data.msPembagianLabaDividenThIni : null,
      msPembagianLabaCadanganThIni: data ? data.msPembagianLabaCadanganThIni : null,
      msPembagianLabaTantiemJasprodThIni: data ? data.msPembagianLabaTantiemJasprodThIni : null,
      msTambahanModalDisetorThIni: data ? data.msTambahanModalDisetorThIni : null,
      msLabaRugiTahunBerjalanThIni: data ? data.msLabaRugiTahunBerjalanThIni : null,
      msPenambahanEkuitasLainnyaThIni: data ? data.msPenambahanEkuitasLainnyaThIni : null,
      msPenghasilanKomprehensifLainThIni: data ? data.msPenghasilanKomprehensifLainThIni : null,
      msSaldoAkhirThIni: data ? data.msSaldoAkhirThIni : null,


      // Komponen Ekuitas Lainnya
      kelSaldoAwalTahunThLalu: data ? data.kelSaldoAwalTahunThLalu : null,
      kelPenyesuaianAwalTahunThLalu: data ? data.kelPenyesuaianAwalTahunThLalu : null,
      kelSaldoSetelahPenyesuaianThLalu: data ? data.kelSaldoSetelahPenyesuaianThLalu : null,
      kelPembagianLabaDividenThLalu: data ? data.kelPembagianLabaDividenThLalu : null,
      kelPembagianLabaCadanganThLalu: data ? data.kelPembagianLabaCadanganThLalu : null,
      kelPembagianLabaTantiemJasprodThLalu: data ? data.kelPembagianLabaTantiemJasprodThLalu : null,
      kelTambahanModalDisetorThLalu: data ? data.kelTambahanModalDisetorThLalu : null,
      kelLabaRugiTahunBerjalanThLalu: data ? data.kelLabaRugiTahunBerjalanThLalu : null,
      kelPenambahanEkuitasLainnyaThLalu: data ? data.kelPenambahanEkuitasLainnyaThLalu : null,
      kelPenghasilanKomprehensifLainThLalu: data ? data.kelPenghasilanKomprehensifLainThLalu : null,
      kelSaldoAkhirThLalu: data ? data.kelSaldoAkhirThLalu : null,

      kelPenyesuaianAwalTahunThIni: data ? data.kelPenyesuaianAwalTahunThIni : null,
      kelSaldoSetelahPenyesuaianThIni: data ? data.kelSaldoSetelahPenyesuaianThIni : null,
      kelPembagianLabaDividenThIni: data ? data.kelPembagianLabaDividenThIni : null,
      kelPembagianLabaCadanganThIni: data ? data.kelPembagianLabaCadanganThIni : null,
      kelPembagianLabaTantiemJasprodThIni: data ? data.kelPembagianLabaTantiemJasprodThIni : null,
      kelTambahanModalDisetorThIni: data ? data.kelTambahanModalDisetorThIni : null,
      kelLabaRugiTahunBerjalanThIni: data ? data.kelLabaRugiTahunBerjalanThIni : null,
      kelPenambahanEkuitasLainnyaThIni: data ? data.kelPenambahanEkuitasLainnyaThIni : null,
      kelPenghasilanKomprehensifLainThIni: data ? data.kelPenghasilanKomprehensifLainThIni : null,
      kelSaldoAkhirThIni: data ? data.kelSaldoAkhirThIni : null,


      // telah ditentukan penggunaannya
      tdpSaldoAwalTahunThLalu: data ? data.tdpSaldoAwalTahunThLalu : null,
      tdpPenyesuaianAwalTahunThLalu: data ? data.tdpPenyesuaianAwalTahunThLalu : null,
      tdpSaldoSetelahPenyesuaianThLalu: data ? data.tdpSaldoSetelahPenyesuaianThLalu : null,
      tdpPembagianLabaDividenThLalu: data ? data.tdpPembagianLabaDividenThLalu : null,
      tdpPembagianLabaCadanganThLalu: data ? data.tdpPembagianLabaCadanganThLalu : null,
      tdpPembagianLabaTantiemJasprodThLalu: data ? data.tdpPembagianLabaTantiemJasprodThLalu : null,
      tdpTambahanModalDisetorThLalu: data ? data.tdpTambahanModalDisetorThLalu : null,
      tdpLabaRugiTahunBerjalanThLalu: data ? data.tdpLabaRugiTahunBerjalanThLalu : null,
      tdpPenambahanEkuitasLainnyaThLalu: data ? data.tdpPenambahanEkuitasLainnyaThLalu : null,
      tdpPenghasilanKomprehensifLainThLalu: data ? data.tdpPenghasilanKomprehensifLainThLalu : null,
      tdpSaldoAkhirThLalu: data ? data.tdpSaldoAkhirThLalu : null,

      tdpPenyesuaianAwalTahunThIni: data ? data.tdpPenyesuaianAwalTahunThIni : null,
      tdpSaldoSetelahPenyesuaianThIni: data ? data.tdpSaldoSetelahPenyesuaianThIni : null,
      tdpPembagianLabaDividenThIni: data ? data.tdpPembagianLabaDividenThIni : null,
      tdpPembagianLabaCadanganThIni: data ? data.tdpPembagianLabaCadanganThIni : null,
      tdpPembagianLabaTantiemJasprodThIni: data ? data.tdpPembagianLabaTantiemJasprodThIni : null,
      tdpTambahanModalDisetorThIni: data ? data.tdpTambahanModalDisetorThIni : null,
      tdpLabaRugiTahunBerjalanThIni: data ? data.tdpLabaRugiTahunBerjalanThIni : null,
      tdpPenambahanEkuitasLainnyaThIni: data ? data.tdpPenambahanEkuitasLainnyaThIni : null,
      tdpPenghasilanKomprehensifLainThIni: data ? data.tdpPenghasilanKomprehensifLainThIni : null,
      tdpSaldoAkhirThIni: data ? data.tdpSaldoAkhirThIni : null,


      // belum ditentukan penggunaannya
      bdpSaldoAwalTahunThLalu: data ? data.bdpSaldoAwalTahunThLalu : null,
      bdpPenyesuaianAwalTahunThLalu: data ? data.bdpPenyesuaianAwalTahunThLalu : null,
      bdpSaldoSetelahPenyesuaianThLalu: data ? data.bdpSaldoSetelahPenyesuaianThLalu : null,
      bdpPembagianLabaDividenThLalu: data ? data.bdpPembagianLabaDividenThLalu : null,
      bdpPembagianLabaCadanganThLalu: data ? data.bdpPembagianLabaCadanganThLalu : null,
      bdpPembagianLabaTantiemJasprodThLalu: data ? data.bdpPembagianLabaTantiemJasprodThLalu : null,
      bdpTambahanModalDisetorThLalu: data ? data.bdpTambahanModalDisetorThLalu : null,
      bdpLabaRugiTahunBerjalanThLalu: data ? data.bdpLabaRugiTahunBerjalanThLalu : null,
      bdpPenambahanEkuitasLainnyaThLalu: data ? data.bdpPenambahanEkuitasLainnyaThLalu : null,
      bdpPenghasilanKomprehensifLainThLalu: data ? data.bdpPenghasilanKomprehensifLainThLalu : null,
      bdpSaldoAkhirThLalu: data ? data.bdpSaldoAkhirThLalu : null,

      bdpPenyesuaianAwalTahunThIni: data ? data.bdpPenyesuaianAwalTahunThIni : null,
      bdpSaldoSetelahPenyesuaianThIni: data ? data.bdpSaldoSetelahPenyesuaianThIni : null,
      bdpPembagianLabaDividenThIni: data ? data.bdpPembagianLabaDividenThIni : null,
      bdpPembagianLabaCadanganThIni: data ? data.bdpPembagianLabaCadanganThIni : null,
      bdpPembagianLabaTantiemJasprodThIni: data ? data.bdpPembagianLabaTantiemJasprodThIni : null,
      bdpTambahanModalDisetorThIni: data ? data.bdpTambahanModalDisetorThIni : null,
      bdpLabaRugiTahunBerjalanThIni: data ? data.bdpLabaRugiTahunBerjalanThIni : null,
      bdpPenambahanEkuitasLainnyaThIni: data ? data.bdpPenambahanEkuitasLainnyaThIni : null,
      bdpPenghasilanKomprehensifLainThIni: data ? data.bdpPenghasilanKomprehensifLainThIni : null,
      bdpSaldoAkhirThIni: data ? data.bdpSaldoAkhirThIni : null,

      // jumlah
      jumlahSaldoAwalTahunThLalu: data ? data.jumlahSaldoAwalTahunThLalu : null,
      jumlahPenyesuaianAwalTahunThLalu: data ? data.jumlahPenyesuaianAwalTahunThLalu : null,
      jumlahSaldoSetelahPenyesuaianThLalu: data ? data.jumlahSaldoSetelahPenyesuaianThLalu : null,
      jumlahPembagianLabaDividenThLalu: data ? data.jumlahPembagianLabaDividenThLalu : null,
      jumlahPembagianLabaCadanganThLalu: data ? data.jumlahPembagianLabaCadanganThLalu : null,
      jumlahPembagianLabaTantiemJasprodThLalu: data ? data.jumlahPembagianLabaTantiemJasprodThLalu : null,
      jumlahTambahanModalDisetorThLalu: data ? data.jumlahTambahanModalDisetorThLalu : null,
      jumlahLabaRugiTahunBerjalanThLalu: data ? data.jumlahLabaRugiTahunBerjalanThLalu : null,
      jumlahPenambahanEkuitasLainnyaThLalu: data ? data.jumlahPenambahanEkuitasLainnyaThLalu : null,
      jumlahPenghasilanKomprehensifLainThLalu: data ? data.jumlahPenghasilanKomprehensifLainThLalu : null,
      jumlahSaldoAkhirThLalu: data ? data.jumlahSaldoAkhirThLalu : null,

      jumlahPenyesuaianAwalTahunThIni: data ? data.jumlahPenyesuaianAwalTahunThIni : null,
      jumlahSaldoSetelahPenyesuaianThIni: data ? data.jumlahSaldoSetelahPenyesuaianThIni : null,
      jumlahPembagianLabaDividenThIni: data ? data.jumlahPembagianLabaDividenThIni : null,
      jumlahPembagianLabaCadanganThIni: data ? data.jumlahPembagianLabaCadanganThIni : null,
      jumlahPembagianLabaTantiemJasprodThIni: data ? data.jumlahPembagianLabaTantiemJasprodThIni : null,
      jumlahTambahanModalDisetorThIni: data ? data.jumlahTambahanModalDisetorThIni : null,
      jumlahLabaRugiTahunBerjalanThIni: data ? data.jumlahLabaRugiTahunBerjalanThIni : null,
      jumlahPenambahanEkuitasLainnyaThIni: data ? data.jumlahPenambahanEkuitasLainnyaThIni : null,
      jumlahPenghasilanKomprehensifLainThIni: data ? data.jumlahPenghasilanKomprehensifLainThIni : null,
      jumlahSaldoAkhirThIni: data ? data.jumlahSaldoAkhirThIni : null,


      // komponen non pengendali
      knpSaldoAwalTahunThLalu: data ? data.knpSaldoAwalTahunThLalu : null,
      knpPenyesuaianAwalTahunThLalu: data ? data.knpPenyesuaianAwalTahunThLalu : null,
      knpSaldoSetelahPenyesuaianThLalu: data ? data.knpSaldoSetelahPenyesuaianThLalu : null,
      knpPembagianLabaDividenThLalu: data ? data.knpPembagianLabaDividenThLalu : null,
      knpPembagianLabaCadanganThLalu: data ? data.knpPembagianLabaCadanganThLalu : null,
      knpPembagianLabaTantiemJasprodThLalu: data ? data.knpPembagianLabaTantiemJasprodThLalu : null,
      knpTambahanModalDisetorThLalu: data ? data.knpTambahanModalDisetorThLalu : null,
      knpLabaRugiTahunBerjalanThLalu: data ? data.knpLabaRugiTahunBerjalanThLalu : null,
      knpPenambahanEkuitasLainnyaThLalu: data ? data.knpPenambahanEkuitasLainnyaThLalu : null,
      knpPenghasilanKomprehensifLainThLalu: data ? data.knpPenghasilanKomprehensifLainThLalu : null,
      knpSaldoAkhirThLalu: data ? data.knpSaldoAkhirThLalu : null,

      knpPenyesuaianAwalTahunThIni: data ? data.knpPenyesuaianAwalTahunThIni : null,
      knpSaldoSetelahPenyesuaianThIni: data ? data.knpSaldoSetelahPenyesuaianThIni : null,
      knpPembagianLabaDividenThIni: data ? data.knpPembagianLabaDividenThIni : null,
      knpPembagianLabaCadanganThIni: data ? data.knpPembagianLabaCadanganThIni : null,
      knpPembagianLabaTantiemJasprodThIni: data ? data.knpPembagianLabaTantiemJasprodThIni : null,
      knpTambahanModalDisetorThIni: data ? data.knpTambahanModalDisetorThIni : null,
      knpLabaRugiTahunBerjalanThIni: data ? data.knpLabaRugiTahunBerjalanThIni : null,
      knpPenambahanEkuitasLainnyaThIni: data ? data.knpPenambahanEkuitasLainnyaThIni : null,
      knpPenghasilanKomprehensifLainThIni: data ? data.knpPenghasilanKomprehensifLainThIni : null,
      knpSaldoAkhirThIni: data ? data.knpSaldoAkhirThIni : null,


      // jumlah Ekuitas
      jumlahEkuitasSaldoAwalTahunThLalu: data ? data.jumlahEkuitasSaldoAwalTahunThLalu : null,
      jumlahEkuitasPenyesuaianAwalTahunThLalu: data ? data.jumlahEkuitasPenyesuaianAwalTahunThLalu : null,
      jumlahEkuitasSaldoSetelahPenyesuaianThLalu: data ? data.jumlahEkuitasSaldoSetelahPenyesuaianThLalu : null,
      jumlahEkuitasPembagianLabaDividenThLalu: data ? data.jumlahEkuitasPembagianLabaDividenThLalu : null,
      jumlahEkuitasPembagianLabaCadanganThLalu: data ? data.jumlahEkuitasPembagianLabaCadanganThLalu : null,
      jumlahEkuitasPembagianLabaTantiemJasprodThLalu: data ? data.jumlahEkuitasPembagianLabaTantiemJasprodThLalu : null,
      jumlahEkuitasTambahanModalDisetorThLalu: data ? data.jumlahEkuitasTambahanModalDisetorThLalu : null,
      jumlahEkuitasLabaRugiTahunBerjalanThLalu: data ? data.jumlahEkuitasLabaRugiTahunBerjalanThLalu : null,
      jumlahEkuitasPenambahanEkuitasLainnyaThLalu: data ? data.jumlahEkuitasPenambahanEkuitasLainnyaThLalu : null,
      jumlahEkuitasPenghasilanKomprehensifLainThLalu: data ? data.jumlahEkuitasPenghasilanKomprehensifLainThLalu : null,
      jumlahEkuitasSaldoAkhirThLalu: data ? data.jumlahEkuitasSaldoAkhirThLalu : null,

      jumlahEkuitasPenyesuaianAwalTahunThIni: data ? data.jumlahEkuitasPenyesuaianAwalTahunThIni : null,
      jumlahEkuitasSaldoSetelahPenyesuaianThIni: data ? data.jumlahEkuitasSaldoSetelahPenyesuaianThIni : null,
      jumlahEkuitasPembagianLabaDividenThIni: data ? data.jumlahEkuitasPembagianLabaDividenThIni : null,
      jumlahEkuitasPembagianLabaCadanganThIni: data ? data.jumlahEkuitasPembagianLabaCadanganThIni : null,
      jumlahEkuitasPembagianLabaTantiemJasprodThIni: data ? data.jumlahEkuitasPembagianLabaTantiemJasprodThIni : null,
      jumlahEkuitasTambahanModalDisetorThIni: data ? data.jumlahEkuitasTambahanModalDisetorThIni : null,
      jumlahEkuitasLabaRugiTahunBerjalanThIni: data ? data.jumlahEkuitasLabaRugiTahunBerjalanThIni : null,
      jumlahEkuitasPenambahanEkuitasLainnyaThIni: data ? data.jumlahEkuitasPenambahanEkuitasLainnyaThIni : null,
      jumlahEkuitasPenghasilanKomprehensifLainThIni: data ? data.jumlahEkuitasPenghasilanKomprehensifLainThIni : null,
      jumlahEkuitasSaldoAkhirThIni: data ? data.jumlahEkuitasSaldoAkhirThIni : null,


    });
  }, [reportReducer.dataReport]);

  if (reportReducer.isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <>
      <h3 className="mb-4">
        Laporan Perubahan Ekuitas - {filter.labelMonth} {filter.yearFilter}
      </h3>
      <Table bordered hover>
        <thead>
          <tr>
            <td></td>
            <td width={'14%'}>Modal Saham</td>
            <td width={'14%'}>Komponen Ekuitas Lainnya</td>
            <td width={'14%'}>Telah ditentukan Penggunaannya</td>
            <td width={'14%'}>Belum ditentukan penggunaannya</td>
            <td width={'14%'}>Jumlah</td>
            <td width={'14%'}>komponen Non Pengendali</td>
            <td width={'14%'}>jumlah Ekuitas</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Saldo Awal Tahun 20XX - 1</th>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msSaldoAwalTahunThLalu,
                  name: "msSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelSaldoAwalTahunThLalu,
                  name: "kelSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpSaldoAwalTahunThLalu,
                  name: "tdpSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpSaldoAwalTahunThLalu,
                  name: "bdpSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahSaldoAwalTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahSaldoAwalTahunThLalu,
                  name: "jumlahSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpSaldoAwalTahunThLalu,
                  name: "knpSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasSaldoAwalTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasSaldoAwalTahunThLalu,
                  name: "jumlahEkuitasSaldoAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Penyesuaian Awal Tahun 200xx -1</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenyesuaianAwalTahunThLalu,
                  name: "msPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenyesuaianAwalTahunThLalu,
                  name: "kelPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenyesuaianAwalTahunThLalu,
                  name: "tdpPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenyesuaianAwalTahunThLalu,
                  name: "bdpPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenyesuaianAwalTahunY1(dataInput)).format(0, 0)}
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenyesuaianAwalTahunThLalu,
                  name: "knpPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenyesuaianAwalTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenyesuaianAwalTahunThLalu,
                  name: "jumlahEkuitasPenyesuaianAwalTahunThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Saldo Setelah Penyesuaian</td>
            <td>
              {numeral(formula.modalSahamSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.komponenEkuitasLainnyaSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.telahDitentukanPenggunaannyaSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.belumDitentukanPenggunaannyaSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.jumlahSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.komponenNonPengendaliSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.jumlahEkuitasSaldoSetelahPenyesuaianY1(dataInput)).format(0, 0)}
            </td>
          </tr>
          <tr>
            <td>Deviden</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaDividenThLalu,
                  name: "msPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaDividenThLalu,
                  name: "kelPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaDividenThLalu,
                  name: "tdpPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaDividenThLalu,
                  name: "bdpPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahDevidenTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaDividenThLalu,
                  name: "jumlahPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaDividenThLalu,
                  name: "knpPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasDevidenTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaDividenThLalu,
                  name: "jumlahEkuitasPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Cadangan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaCadanganThLalu,
                  name: "msPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaCadanganThLalu,
                  name: "kelPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaCadanganThLalu,
                  name: "tdpPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaCadanganThLalu,
                  name: "bdpPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPembagianCadanganTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaCadanganThLalu,
                  name: "jumlahPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaCadanganThLalu,
                  name: "knpPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPembagianCadanganTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaCadanganThLalu,
                  name: "jumlahEkuitasPembagianLabaCadanganThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Tantiem dan Jasprod</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaTantiemJasprodThLalu,
                  name: "msPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaTantiemJasprodThLalu,
                  name: "kelPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaTantiemJasprodThLalu,
                  name: "tdpPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaTantiemJasprodThLalu,
                  name: "bdpPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPembagianLabaTantiemJasprodTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaTantiemJasprodThLalu,
                  name: "jumlahPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaTantiemJasprodThLalu,
                  name: "knpPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPembagianLabaTantiemJasprodTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaTantiemJasprodThLalu,
                  name: "jumlahEkuitasPembagianLabaTantiemJasprodThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Tambahan Modal Disetor</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msTambahanModalDisetorThLalu,
                  name: "msTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelTambahanModalDisetorThLalu,
                  name: "kelTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpTambahanModalDisetorThLalu,
                  name: "tdpTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpTambahanModalDisetorThLalu,
                  name: "bdpTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahTambahanModalDisetorTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahTambahanModalDisetorThLalu,
                  name: "jumlahTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpTambahanModalDisetorThLalu,
                  name: "knpTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasTambahanModalDisetorTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasTambahanModalDisetorThLalu,
                  name: "jumlahEkuitasTambahanModalDisetorThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Laba (Rugi) Tahun Berjalan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msLabaRugiTahunBerjalanThLalu,
                  name: "msLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelLabaRugiTahunBerjalanThLalu,
                  name: "kelLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpLabaRugiTahunBerjalanThLalu,
                  name: "tdpLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpLabaRugiTahunBerjalanThLalu,
                  name: "bdpLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahLabaRugiTahunBerjalanTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahLabaRugiTahunBerjalanThLalu,
                  name: "jumlahLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpLabaRugiTahunBerjalanThLalu,
                  name: "knpLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasLabaRugiTahunBerjalanTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasLabaRugiTahunBerjalanThLalu,
                  name: "jumlahEkuitasLabaRugiTahunBerjalanThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Penambahan Ekuitas Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenambahanEkuitasLainnyaThLalu,
                  name: "msPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenambahanEkuitasLainnyaThLalu,
                  name: "kelPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenambahanEkuitasLainnyaThLalu,
                  name: "tdpPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenambahanEkuitasLainnyaThLalu,
                  name: "bdpPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenambahanEkuitasLainnyaTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPenambahanEkuitasLainnyaThLalu,
                  name: "jumlahPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenambahanEkuitasLainnyaThLalu,
                  name: "knpPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenambahanEkuitasLainnyaTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenambahanEkuitasLainnyaThLalu,
                  name: "jumlahEkuitasPenambahanEkuitasLainnyaThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Penghasilan Komprehensif Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenghasilanKomprehensifLainThLalu,
                  name: "msPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenghasilanKomprehensifLainThLalu,
                  name: "kelPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenghasilanKomprehensifLainThLalu,
                  name: "tdpPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenghasilanKomprehensifLainThLalu,
                  name: "bdpPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenghasilanKomprehensifLainTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPenghasilanKomprehensifLainThLalu,
                  name: "jumlahPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenghasilanKomprehensifLainThLalu,
                  name: "knpPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenghasilanKomprehensifLainTahunY1(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenghasilanKomprehensifLainThLalu,
                  name: "jumlahEkuitasPenghasilanKomprehensifLainThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <th>Saldo Akhir Tahun 200xx - 1</th>
            <th>
              {numeral(formula.modalSahamSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.komponenEkuitasLainnyaSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.telahDitentukanPenggunaannyaSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.belumDitentukanPenggunaannyaSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.jumlahSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.komponenNonPengendaliSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.jumlahEkuitasSaldoAkhirTahunY1(dataInput)).format(0, 0)}
            </th>
          </tr>
          <tr>
            <th></th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Penyesuaian Awal Tahun 200xx</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenyesuaianAwalTahunThIni,
                  name: "msPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenyesuaianAwalTahunThIni,
                  name: "kelPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenyesuaianAwalTahunThIni,
                  name: "tdpPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenyesuaianAwalTahunThIni,
                  name: "bdpPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenyesuaianAwalTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPenyesuaianAwalTahunThIni,
                  name: "jumlahPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenyesuaianAwalTahunThIni,
                  name: "knpPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenyesuaianAwalTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenyesuaianAwalTahunThIni,
                  name: "jumlahEkuitasPenyesuaianAwalTahunThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Saldo Setelah Penyesuaian</td>
            <td>
              {numeral(formula.modalSahamSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.komponenEkuitasLainnyaSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.telahDitentukanPenggunaannyaSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.belumDitentukanPenggunaannyaSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.jumlahSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.komponenNonPengendaliSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
            <td>
              {numeral(formula.jumlahEkuitasSaldoSetelahPenyesuaianY(dataInput)).format(0, 0)}
            </td>
          </tr>
          <tr>
            <td>Deviden</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaDividenThIni,
                  name: "msPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaDividenThIni,
                  name: "kelPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaDividenThIni,
                  name: "tdpPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaDividenThIni,
                  name: "bdpPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahDevidenTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaDividenThLalu,
                  name: "jumlahPembagianLabaDividenThLalu",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaDividenThIni,
                  name: "knpPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasDevidenTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaDividenThIni,
                  name: "jumlahEkuitasPembagianLabaDividenThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Cadangan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaCadanganThIni,
                  name: "msPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaCadanganThIni,
                  name: "kelPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaCadanganThIni,
                  name: "tdpPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaCadanganThIni,
                  name: "bdpPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPembagianCadanganTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaCadanganThIni,
                  name: "jumlahPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaCadanganThIni,
                  name: "knpPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPembagianCadanganTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaCadanganThIni,
                  name: "jumlahEkuitasPembagianLabaCadanganThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Tantiem dan Jasprod</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPembagianLabaTantiemJasprodThIni,
                  name: "msPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPembagianLabaTantiemJasprodThIni,
                  name: "kelPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPembagianLabaTantiemJasprodThIni,
                  name: "tdpPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPembagianLabaTantiemJasprodThIni,
                  name: "bdpPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPembagianLabaTantiemJasprodTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPembagianLabaTantiemJasprodThIni,
                  name: "jumlahPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPembagianLabaTantiemJasprodThIni,
                  name: "knpPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPembagianLabaTantiemJasprodTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPembagianLabaTantiemJasprodThIni,
                  name: "jumlahEkuitasPembagianLabaTantiemJasprodThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Tambahan Modal Disetor</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msTambahanModalDisetorThIni,
                  name: "msTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelTambahanModalDisetorThIni,
                  name: "kelTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpTambahanModalDisetorThIni,
                  name: "tdpTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpTambahanModalDisetorThIni,
                  name: "bdpTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahTambahanModalDisetorTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahTambahanModalDisetorThIni,
                  name: "jumlahTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpTambahanModalDisetorThIni,
                  name: "knpTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasTambahanModalDisetorTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasTambahanModalDisetorThIni,
                  name: "jumlahEkuitasTambahanModalDisetorThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Laba (Rugi) Tahun Berjalan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msLabaRugiTahunBerjalanThIni,
                  name: "msLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelLabaRugiTahunBerjalanThIni,
                  name: "kelLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpLabaRugiTahunBerjalanThIni,
                  name: "tdpLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpLabaRugiTahunBerjalanThIni,
                  name: "bdpLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahLabaRugiTahunBerjalanTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahLabaRugiTahunBerjalanThIni,
                  name: "jumlahLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpLabaRugiTahunBerjalanThIni,
                  name: "knpLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasLabaRugiTahunBerjalanTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasLabaRugiTahunBerjalanThIni,
                  name: "jumlahEkuitasLabaRugiTahunBerjalanThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Penambahan Ekuitas Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenambahanEkuitasLainnyaThIni,
                  name: "msPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenambahanEkuitasLainnyaThIni,
                  name: "kelPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenambahanEkuitasLainnyaThIni,
                  name: "tdpPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenambahanEkuitasLainnyaThIni,
                  name: "bdpPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenambahanEkuitasLainnyaTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPenambahanEkuitasLainnyaThIni,
                  name: "jumlahPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenambahanEkuitasLainnyaThIni,
                  name: "knpPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenambahanEkuitasLainnyaTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenambahanEkuitasLainnyaThIni,
                  name: "jumlahEkuitasPenambahanEkuitasLainnyaThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <td>Penghasilan Komprehensif Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.msPenghasilanKomprehensifLainThIni,
                  name: "msPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kelPenghasilanKomprehensifLainThIni,
                  name: "kelPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tdpPenghasilanKomprehensifLainThIni,
                  name: "tdpPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bdpPenghasilanKomprehensifLainThIni,
                  name: "bdpPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahPenghasilanKomprehensifLainTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahPenghasilanKomprehensifLainThIni,
                  name: "jumlahPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.knpPenghasilanKomprehensifLainThIni,
                  name: "knpPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {numeral(formula.jumlahEkuitasPenghasilanKomprehensifLainTahunY(dataInput)).format(0, 0)}
            </td>
            {/* <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.jumlahEkuitasPenghasilanKomprehensifLainThIni,
                  name: "jumlahEkuitasPenghasilanKomprehensifLainThIni",
                  type: "currency",
                }}
                onChange={handleChange}
              />
          </td> */}
          </tr>
          <tr>
            <th>Saldo Akhir Tahun 200xx</th>
            <th>
              {numeral(formula.modalSahamSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.komponenEkuitasLainnyaSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.telahDitentukanPenggunaannyaSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.belumDitentukanPenggunaannyaSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.jumlahSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.komponenNonPengendaliSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
            <th>
              {numeral(formula.jumlahEkuitasSaldoAkhirTahunY(dataInput)).format(0, 0)}
            </th>
          </tr>

        </tbody>
      </Table>

      {!disabledInput && (
        <Button
          color="blue"
          disabled={props.isLoadingButton}
          loading={props.isLoadingButton}
          onClick={handleSubmit}
        >
          Simpan
        </Button>
      )}
    </>
  );
};
